/**
 * Persistencia efímera del flujo de login (no guarda tokens).
 *
 * El `accessToken` vive solo en memoria (evita XSS). Entre el primer factor y el
 * segundo solo necesitamos el `userId` pendiente y el email, que se guardan en
 * `sessionStorage` para sobrevivir un refresh de la página.
 */
const PENDING_USER_ID_KEY = 'goelectric.admin.pendingUserId';
const LOGIN_EMAIL_KEY = 'goelectric.admin.loginEmail';

function sessionStore(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function savePendingUserId(userId: string): void {
  sessionStore()?.setItem(PENDING_USER_ID_KEY, userId);
}

export function readPendingUserId(): string | null {
  return sessionStore()?.getItem(PENDING_USER_ID_KEY) ?? null;
}

export function clearPendingUserId(): void {
  sessionStore()?.removeItem(PENDING_USER_ID_KEY);
}

export function saveLoginEmail(email: string): void {
  sessionStore()?.setItem(LOGIN_EMAIL_KEY, email);
}

export function readLoginEmail(): string | null {
  return sessionStore()?.getItem(LOGIN_EMAIL_KEY) ?? null;
}

export function clearLoginEmail(): void {
  sessionStore()?.removeItem(LOGIN_EMAIL_KEY);
}
